export default [
  {
    // =============================================================================
    // MAIN LAYOUT ROUTES
    // =============================================================================
    path: '/m',
    component: () => import('@/layouts/m/main/Main.vue'),
    redirect: '/m/login',
    meta: {
      authRequired: true,
      deviceRequired: false
    },
    children: [
      // =============================================================================
      // Theme Routes
      // =============================================================================
      {
        path: 'home',
        name: 'm-home',
        component: () => import('@/views/m/Home.vue'),
        meta: {
          breadcrumb: [
            {
              title: 'Home',
              url: 'home'
            },
            {
              title: '',
              active: true
            }
          ],
          pageTitle: ''
        }
      }
    ]
  }
]
